module.exports = __webpack_public_path__ + "media/images/redesign-images/collegiate/collegiate-starts-1-medium-b942ee325bdb79479c2695fbb8bf24a3.jpg";